import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class WarehouseWorkTrackingProvider extends HttpRequest {
  // ===== Employees =====

  getEmployees (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/employees', query)
  }

  getEmployeesByPaginate (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/warehouse-work-trackers/employees', query)
  }

  getEmployeeById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/warehouse-work-trackers/employees/${id}`)
  }

  createEmployee (payload) {
    this.setHeader(getAuthToken())
    return this.post('/warehouse-work-trackers/employees', payload)
  }

  updateEmployee (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/warehouse-work-trackers/employees/${id}`, payload)
  }

  updateEmployeeStatus (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/warehouse-work-trackers/employees/${id}/status`, payload)
  }

  deleteEmployee (id) {
    this.setHeader(getAuthToken())
    return this.remove(`/warehouse-work-trackers/employees/${id}`)
  }

  // ===== Task Types =====

  getTaskTypes (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/task-types', query)
  }

  createTaskType (payload) {
    this.setHeader(getAuthToken())
    return this.post('/warehouse-work-trackers/task-types', payload)
  }

  updateTaskType (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/warehouse-work-trackers/task-types/${id}`, payload)
  }

  updateTaskTypeStatus (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/warehouse-work-trackers/task-types/${id}/status`, payload)
  }

  deleteTaskType (id) {
    this.setHeader(getAuthToken())
    return this.remove(`/warehouse-work-trackers/task-types/${id}`)
  }

  // ===== Attendance =====

  getAttendanceToday (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/attendance/today', query)
  }

  getAttendanceRange (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/attendance', query)
  }

  // ===== Employee Status =====

  getEmployeeStatus () {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/employee-status')
  }

  // ===== Work Logs =====

  getWorkLogsByPaginate (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/warehouse-work-trackers/logs', query)
  }

  getActiveTasks (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/tasks/active', query)
  }

  // ===== Reports =====

  getReportDashboard (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/reports/dashboard', query)
  }

  getReportSummary (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/reports/summary', query)
  }

  getReportByEmployee (employeeId, query) {
    this.setHeader(getAuthToken())
    return this.get(`/warehouse-work-trackers/reports/employee/${employeeId}`, query)
  }

  getReportPerformance (query) {
    this.setHeader(getAuthToken())
    return this.get('/warehouse-work-trackers/reports/performance', query)
  }
}

export default WarehouseWorkTrackingProvider
